export const en = {
  locale: 'en',
  messages: {

    // Global
    aff_logo: 'Affiliate Panel',

    id: 'ID',
    name: 'Name',
    surname: 'Surname',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    password: 'Password',
    registered: 'Registered',
    last_login: 'Last Login',

    add_new: 'Add new',
    add: 'Add',

    next: 'Next',
    back: 'Back',

    settings: 'Settings',
    filter: 'Filter',
    language: 'Language',
    state: 'State',
    currency: 'Currency',
    edit: 'Edit',

    save: 'Save',
    cancel: 'Cancel',

    date: 'Date',
    start_date: 'Start Date',
    end_date: 'End Date',

    total_rows: 'Total Rows',
    total: 'Total',
    summary: 'Summary',
    count: 'Count',

    active: 'Active',
    inactive: 'Inactive',
    block: 'Block',
    blocked: 'Blocked',
    blocked_by_admin: 'Blocked by admin',

    balance: 'Balance',
    amount: 'Amount',

    // Statuses
    status: 'Status',
    pending: 'Pending',
    waiting: 'Waiting',
    success: 'Success',
    cancelled: 'Cancelled',
    approve: 'Approve',
    update: 'Update',

    // Sign in
    sign_in: 'Sign In',
    go_to: 'Go to',
    log_out: 'Log out',

    //Sign Up
    sign_up: 'Sign Up',
    referral_id: 'Referral ID',
    company_name: 'Company Name',
    phone_number: 'Phone Number',
    account_question: 'Already have an account?',

    // Forgot Password
    forgot_password: 'Forgot password?',
    send_verification_code: 'Get verification code',
    recover_by: 'Method',
    verification_code_sent: 'The verification code has been successfuly sent.',
    password_changed: 'Password has been changed successfully.',
    verification_code_required: 'Please input verification code',
    change_password: 'Change Password',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    verification_code: 'Verification code',

    // Validation Messages
    email_required: 'Please input your email.',
    invalid_mail: 'Please input a valid email.',
    password_required: 'Please input your password.',
    please_confirm_password: 'Please Confirm Password.',
    inconsistent_passwords: 'The two passwords do not match.',
    input_phone_number: 'Please input your phone number.',
    invalid_phone_number: 'Please input a valid phone number.',
    invalid_password: 'The password must contain 8-15 characters, both upper and lower case letters, at least one number and one special character.',

    only_number: 'The filed must be only numbers.',
    only_letters: 'The filed must be only letters.',
    sheba_validation: 'Sheba number must start with "IR" followed by 24 numbers with no spaces or other characters.',
    card_number_validation: 'The filed should contain only 16 numbers.',

    name_validation: 'Can be contain letters and numbers.',
    confirm_password: 'Confirm Password',
    name_validation_message: 'Please input a valid name.',
    domain_validation_message: 'Please input a valid domain.',
    human: 'Please, confirm that you are not a robot.',
    input_company_name: 'Please input your company name.',
    input_referral_id: 'Please input Referral ID.',
    invalid_company_name: 'Company name can only contain upper and lower case letters, numbers, "&" and a space.',

    required_field: 'This field is required.',
    required_name: 'Name is required',
    required_domain: 'Domain name is required',

    end_date_validation_message: "End Date  should be greather than Start Date",

    // Messages Text
    success_domain: 'Domain has been successfully added.',
    delete_domain: 'Domain has been successfully deleted.',
    status_changed: 'Status has been successfully changed.',
    permissions_changed: 'Permissions has been successfully changed.',
    commissions_changed: 'Commissions has been successfully changed.',
    withdraw_changed: 'Withdraw status has been successfully changed.',
    confirm_domain_delete: 'Are you sure you want to delete the domain.',
    success_affiliate: 'Affiliate has been successfully added.',
    success_withdraw: 'Withdrawal has been successfully created.',
    delete_affiliate: 'Affiliate has been successfully deleted.',
    confirm_affiliate_delete: 'Are you sure you want to inactive the affiliate.',

    delete_user: 'User has been successfully deleted.',
    update_user: 'User has been successfully updated.',
    confirm_user_delete: 'Are you sure you want to delete the user.',

    // Placeholders
    affiliate_name: 'Affiliate name',
    type_your_name: 'Type in your Name',
    type_your_surname: 'Type in your Surname',
    type_your_referral_id: 'Type in Referral ID',
    type_your_company_name: "Type in your company's name",
    type_your_password: 'Type in your password',
    type_your_email: 'Type in your email',
    type_here: 'Type Here',

    //Affiliates
    affiliates: 'Affiliates',
    affiliate: 'Affiliate',
    aff_name: 'Aff Name',
    aff: 'Aff',
    owner: 'Owner',
    notes: 'Notes',
    preview: 'Preview',
    permissions: 'Permissions',
    advance_withdraw: 'Advance withdraw',
    none: 'None',
    add_remove_domains: 'Add/Remove Domains',
    change_design: 'Change Design',
    topup_players: 'Topup Players',
    commissions: "Commissions",
    view_players_email: "View Players Email",

    // Reports
    reports: 'Reports',
    type: 'Type',
    game: 'Game',
    games: 'Games',

    // Withdraw
    withdraw: 'Withdraw',
    withdrawable_balance: 'Withdrawable Balance',
    withdraw_details: 'Withdraw Details',
    info: 'Info',
    bank_name: 'Bank name',
    sheba_number: 'Sheba Number',
    account_number: 'Account Number',
    card_number: 'Card Number',
    your_name: 'Your Name',

    // User
    users: 'Users',
    add_user: 'Add User',
    main_partner: 'Main Partner',
    sub_affiliate: 'Sub Affiliate',
    select_currency: 'Select Currency',
    select_state: 'Select State',
    select_type: 'Select Type',
    select_language: 'Select Language',
    edit_roles: 'Edit Roles',
    sub: 'Sub',
    forever: 'Forever',

    // Sign Ups
    sign_ups: 'Sign Ups',

    // Players
    players: 'Players',
    top_up: 'Top Up',
    register_start: 'Register Start Date',
    register_end: 'Register End Date',
    login_start_date: 'Last Login Start Date',
    login_end_date: 'Last Login End Date',

    // Domains
    domains: 'Domains',
    domain: 'Domain',
    your_domain: 'Your Domain',
    edit_domain: 'Edit Domain',
    add_domain: 'Add Domain',
    check_activity: 'Check Activity',

    // Designs
    designs: 'Designs',

    // Account
    account: 'Account',

    ns_1: 'Name Server 1',
    ns_2: 'Name Server 2',
    live_chat: 'Live Chat'

  }
};

export default en;


// WEBPACK FOOTER //
// ./src/translations/en.js